export default __webpack_public_path__ + "static/media/supraman.439aecc1.png";